import {createErrorHandlingThunk} from "./utils";
import firebase from "firebase";
import {UserAuthorization} from "./types";
import {AuthService} from "./Auth.service";

const authService = new AuthService();

export const loginThunk = createErrorHandlingThunk<firebase.auth.UserCredential, { email: string; password: string }>('login', arg =>
    firebase.auth().signInWithEmailAndPassword(arg.email, arg.password)
);

export const logoutThunk = createErrorHandlingThunk('logout', () => {
    firebase.auth().signOut();
    localStorage.clear();
});

export const getUserRoleThunk = createErrorHandlingThunk<UserAuthorization,
    { userId: string }>(
    'user/role',
    (args) => authService.getUserAuthorization(args.userId)
);